import PropTypes from 'prop-types';
import React from 'react';

const FieldError = ({ meta: { touched, error } }) => {
  // console.log('FieldError: ', error, Array.isArray(error));
  const errMsg = Array.isArray(error) ? error[0] : error;
  return (
    (touched &&
      error && (
        <span className="field-error" style={{ fontSize: 12 }}>
          {errMsg}
        </span>
      )) ||
    null
  );
};

FieldError.propTypes = {
  meta: PropTypes.object.isRequired,
};

export default FieldError;



// WEBPACK FOOTER //
// ./src/components/form/FieldError.js